export const emptyStateStyles = {
	icon: 'w-8 h-8 text-[#6a6977]'
} as const;
